import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box,
    Tooltip
} from '@mui/material';
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import PdfIcon from '@iconify/icons-mdi/note-outline';
import "../../../styles/Auth/return.css";
import { getData } from "../../../webService/webservice.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useStore } from "../../../Context/context.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx"
import Footer from "../Footer/Footer-page.jsx";
import PrintIcon from '@iconify/icons-mdi/printer';
const ReturnList = () => {
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const handleAddReturn = () => {
        navigate('/return/add');
    }
    const [searchQuery, setSearchQuery] = useState('');
    const [returns, setReturns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'Date',
        'Invoice No',
        'Return Invoice No',
        'Biller',
        'Return Product',
        'Total Return Amount',
        'Return Payment Method',
        'Action'
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };


    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const sort = [[sortField, sortOrder]];
    const [stores, setStores] = useState([]);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData("stores/stores", {}, token);
                console.log("API Full Response:", data);

                const results = data?.data?.results || [];
                setStores(results);
            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };

    const fetchReturns = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit: limit === 'all' ? 999999 : limit,
            returnInvoiceNo: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };
        const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        // if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            console.log("Fetching Returns with params:", params);
            const response = await getData("/returns/returns", params);

            if (response?.status !== 200) {
                toast.error(response.message || "Failed to fetch Returns");
                return;
            }

            console.log("Raw API Response:", response);

            const result = response?.data?.[0];
            const returnList = result?.paginatedResults || [];
            const totalCount = result?.totalCount || 0;
            const totalPages = result?.totalPages || 0;

            console.log("Return List:", returnList);
            setReturns(returnList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Returns");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchReturns(currentPage, limit, searchQuery, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, store]);

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);


    const downloadReturnPDF = async (returnItem) => {
        try {
            // returnItem is already a single row from the table
            const invoice = returnItem?.invoiceDetails?.[0] || {};
            const customer = returnItem?.customerDetails?.[0] || {};
            const store = returnItem?.storeDetails?.[0] || {};

            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.left = "-9999px"; // hide offscreen
            container.innerHTML = generateReturnHTML(returnItem, invoice, customer, store);
            document.body.appendChild(container);

            const canvas = await html2canvas(container, { scale: 2 });
            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: [80, 250]
            });
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(`Return-Invoice-${invoice.invoiceNo || returnItem._id}.pdf`);

            document.body.removeChild(container);
        } catch (err) {
            console.error("PDF generation error:", err);
        }
    };

    const handleExportExcel = () => {
        if (!returns || returns.length === 0) {
            return toast.error("No data available to export");
        }

        const exportData = returns.map((ret, index) => {
            const customer = ret?.customerDetails?.[0] || {};
            const paymentModeText = ret.paymentMode && Array.isArray(ret.paymentMode) && ret.paymentMode.length > 0
                ? ret.paymentMode.map(p => p.method).join(", ")
                : (ret.paymentMethod || "-");

            return {
                "S.NO": index + 1,
                "Date": new Date(ret.createdAt).toLocaleDateString('en-GB') + ', ' + new Date(ret.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }),
                "Invoice No": ret.invoiceDetails?.[0]?.invoiceNo || "-",
                "Return Invoice No": ret.returnInvoiceNo || "-",
                "Customer Name": customer.name || "Walk-in",
                "Customer Phone": customer.phoneNumber || "-",
                "Biller": `${ret.employee?.name} (${ret.employee?.role})`,
                "Total Products": ret.totalProducts,
                "Total Return Amount": (ret.grandTotal ?? 0).toFixed(2),
                "Return Payment Method": paymentModeText,
            };
        });

        const totalReturnSum = returns.reduce((sum, ret) => sum + (ret.grandTotal ?? 0), 0);
        exportData.push({
            "S.NO": "TOTAL",
            "Date": "",
            "Invoice No": "",
            "Return Invoice No": "",
            "Customer Name": "",
            "Customer Phone": "",
            "Biller": "",
            "Total Products": "",
            "Total Return Amount": totalReturnSum.toFixed(2),
            "Return Payment Method": "",
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Returns");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(data, `Returns-List-${new Date().toLocaleDateString('en-GB').replace(/\//g, '-')}.xlsx`);
    };



    const generateReturnHTML = (ret, invoice, customer, store) => {
        const formatCurrency = (num) => `₹${Number(num ?? 0).toFixed(2)}`;

        const paymentSource = (ret.paymentMode && ret.paymentMode.length) ? ret.paymentMode : (invoice.paymentMode || []);
        const paymentModeRows = Array.isArray(paymentSource)
            ? paymentSource.map(p => `<tr><td>${p.method}</td><td style="text-align:right;">${formatCurrency(p.amount)}</td></tr>`).join("")
            : `<tr><td>${ret.paymentMethod || "-"}</td><td style="text-align:right;">-</td></tr>`;

        const billerName = ret?.employee?.name || "-";

        const grandTotal = Number(ret.grandTotal || 0);
        const overallDiscount = Number(ret.discount || 0);
        const sgst = Number(ret.sgst || 0);
        const cgst = Number(ret.cgst || 0);
        const totalGST = sgst + cgst;
        const taxableAmount = Math.max(0, grandTotal - totalGST + overallDiscount);

        const itemsRows = ret.items.map(item => {
            const name = item.productId?.title || item.serviceId?.serviceName || item.description || "Item";
            const lineTotal = (Number(item.price || 0) * Number(item.quantity || 0)) - (Number(item.perItemDiscount || 0) * Number(item.quantity || 0));

            return `
            <tr>
                <td style="padding: 4px 0;">${name}</td>
                <td style="text-align:center; padding: 4px;">${item.quantity}</td>
                <td style="text-align:right; padding: 4px;">${formatCurrency(lineTotal)}</td>
            </tr>
            `;
        }).join("");

        return `
<html>
<head>
<style>
    body { font-family: "Courier New", monospace; font-size: 11px; width: 72mm; margin: 0; padding: 10px; background: #fff; }
    .center { text-align: center; }
    .separator { border-bottom: 1px dashed #000; margin: 8px 0; }
    table { width: 100%; border-collapse: collapse; }
    td, th { padding: 2px 0; }
    .bold { font-weight: bold; }
    .fs-large { font-size: 14px; }
</style>
</head>
<body>
    <div class="center">
        <h3 style="margin: 0;">${store.storeName}</h3>
        <p style="margin: 5px 0; font-weight: bold;">RETURN RECEIPT</p>
        <div class="separator"></div>
    </div>

    <table>
        <tr><td><strong>Return No:</strong></td><td style="text-align:right;">${ret.returnInvoiceNo}</td></tr>
        <tr><td><strong>Ref Inv:</strong></td><td style="text-align:right;">${invoice.invoiceNo || "-"}</td></tr>
        <tr><td><strong>Customer:</strong></td><td style="text-align:right;">${customer.name || "Walk-in"}</td></tr>
        <tr><td><strong>Date:</strong></td><td style="text-align:right;">${new Date(ret.createdAt).toLocaleDateString('en-GB')}, ${new Date(ret.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</td></tr>
        <tr><td><strong>Biller:</strong></td><td style="text-align:right;">${billerName}</td></tr>
    </table>

    <div class="separator"></div>

    <table style="font-size: 10px;">
        <thead>
            <tr style="border-bottom: 1px solid #000;">
                <th style="text-align:left;">Item</th>
                <th style="text-align:center;">Qty</th>
                <th style="text-align:right;">Taxable</th>
                <th style="text-align:right;">GST</th>
                <th style="text-align:right;">Total</th>
            </tr>
        </thead>
        <tbody>
            ${ret.items.map(item => {
            const name = item.productId?.title || item.serviceId?.serviceName || item.description || "Item";
            const taxable = Number(item.total || 0);
            const gst = Number(item.gstAmount || 0);
            return `
                <tr>
                    <td style="padding: 4px 0; max-width: 80px;">${name}</td>
                    <td style="text-align:center; padding: 4px;">${item.quantity}</td>
                    <td style="text-align:right; padding: 4px;">${formatCurrency(taxable)}</td>
                    <td style="text-align:right; padding: 4px;">${formatCurrency(gst)}</td>
                    <td style="text-align:right; padding: 4px;">${formatCurrency(taxable + gst)}</td>
                </tr>
                `;
        }).join("")}
        </tbody>
    </table>

    <div class="separator"></div>

    <table>
        <tr><td>Amount (Before Tax)</td><td style="text-align:right;">${formatCurrency(taxableAmount)}</td></tr>
        ${totalGST > 0 ? `
            <tr><td>Total GST</td><td style="text-align:right;">${formatCurrency(totalGST)}</td></tr>
            <tr style="font-size: 9px; color: #555;">
                <td style="padding-left: 10px;">- CGST</td><td style="text-align:right;">${formatCurrency(cgst)}</td>
            </tr>
            <tr style="font-size: 9px; color: #555;">
                <td style="padding-left: 10px;">- SGST</td><td style="text-align:right;">${formatCurrency(sgst)}</td>
            </tr>
        ` : ""}
        ${overallDiscount > 0 ? `<tr><td>Overall Discount</td><td style="text-align:right;">- ${formatCurrency(overallDiscount)}</td></tr>` : ""}
        <tr class="bold fs-large">
            <td>Grand Total</td>
            <td style="text-align:right;">${formatCurrency(grandTotal)}</td>
        </tr>
    </table>

    <div class="separator"></div>

    <table>
        <tr><td colspan="2" class="bold">Refund Details:</td></tr>
        ${paymentModeRows}
    </table>

    <div class="separator"></div>
    <div class="center"><p style="margin-top: 10px;">*** Refund Processed Successfully ***</p></div>
</body>
</html>`;
    };

    const printReturnInvoice = (returnItem) => {

        const invoice = returnItem?.invoiceDetails?.[0] || {};
        const customer = returnItem?.customerDetails?.[0] || {};
        const store = returnItem?.storeDetails?.[0] || {};

        const receiptHtml = generateReturnHTML(
            returnItem,
            invoice,
            customer,
            store
        );

        const printWindow = window.open("", "_blank");

        printWindow.document.write(receiptHtml);
        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
        };
    };


    return (
        <div className="product-layout">
            <div className="product-content">
                <div className="product-main">
                    <Typography variant="h6" sx={{ mb: 2 }}>Returns</Typography>
                    <div className="product-widgets">
                        <div className="product-widgets-header" style={{ display: "flex", gap: "10px" }}>
                            {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                <StoreSingleAllStoresSelect
                                    value={store}
                                    onChange={
                                        (store) => {
                                            setStore(store)
                                        }
                                    }
                                />
                            )}

                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <button className="add-Product-button" onClick={handleExportExcel}>Export Excel</button>
                            <button className="add-Product-button" onClick={handleAddReturn}>+ Add Return</button>
                        </div>
                    </div>
                    <Box component={Paper}>
                        <TableContainer sx={{
                            maxHeight: 400,
                            overflowY: "auto",
                            '&::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                        }}>
                            <Table className="custom-return-table">
                                <TableHead className="custom-product-head">
                                    <TableRow>
                                        {headings.map((heading, index) => {
                                            const isDate = heading === "Date";
                                            const isReturnInvoiceNo = heading === "Return Invoice No";
                                            const isBiller = heading === "Biller";
                                            const isTotalReturnAmount = heading === "Total Return Amount";
                                            const isReturnPaymentMethod = heading === "Return Payment Method";
                                            const sortKey = isDate
                                                ? "couponCode"
                                                : isReturnInvoiceNo
                                                    ? "returnInvoiceNo"
                                                    : isBiller
                                                        ? "biller"
                                                        : isTotalReturnAmount
                                                            ? "totalReturnAmount"
                                                            : isReturnPaymentMethod
                                                                ? "returnPaymentMethod"
                                                                : null;
                                            return (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: "none",
                                                        padding: "12px 16px",
                                                        textAlign: "center",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "4px",
                                                            color: "#ffffff",
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}

                                                        {sortKey && (
                                                            <span
                                                                onClick={() => handleSort(sortKey)}
                                                                style={{
                                                                    fontSize: "10px",
                                                                    color: "#ffffffff",
                                                                    cursor: "pointer",
                                                                    marginLeft: "4px",
                                                                    userSelect: "none",
                                                                }}
                                                            >
                                                                {sortField === sortKey
                                                                    ? sortOrder === 1
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "▲▼"}
                                                            </span>
                                                        )}
                                                    </Typography>
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {returns.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={9}>
                                                <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                    No returns found.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        returns.map((returnItem, index) => (
                                            <TableRow key={returnItem._id}>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{new Date(returnItem.createdAt).toLocaleDateString('en-GB') + ', ' + new Date(returnItem.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{returnItem.invoiceDetails?.[0]?.invoiceNo || "-"}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{returnItem.returnInvoiceNo || "-"}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}> {
                                                    `${returnItem.employee?.name} (${returnItem.employee?.role})`
                                                }</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{returnItem.totalProducts}</Typography></TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>{(returnItem.grandTotal ?? 0).toFixed(2)}</Typography>
                                                </TableCell>
                                                {/* <TableCell>
                                                    <Typography sx={commonCellStyle}>{returnItem.totalAmount}</Typography>
                                                </TableCell> */}
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {returnItem.paymentMode && Array.isArray(returnItem.paymentMode) && returnItem.paymentMode.length > 0
                                                            ? returnItem.paymentMode.map(p => p.method).join(", ")
                                                            : (returnItem.paymentMethod || "-")}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            gap: 2,
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >

                                                        <Tooltip title="Download Return Invoice" arrow placement="top">
                                                            <Icon
                                                                icon={PdfIcon}
                                                                width={20}
                                                                height={20}
                                                                style={{
                                                                    color: "#300008",
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={() => downloadReturnPDF(returnItem)}
                                                            />
                                                        </Tooltip>

                                                        <Tooltip title="Print Return Invoice" arrow placement="top">
                                                            <Icon
                                                                icon={PrintIcon}
                                                                width={20}
                                                                height={20}
                                                                style={{
                                                                    color: "#300008",
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={() => printReturnInvoice(returnItem)}
                                                            />
                                                        </Tooltip>

                                                    </Box>
                                                </TableCell>
                                            </TableRow>

                                        ))
                                    )}

                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="product-bottom">
                            <div className="return-section show-entries">
                                <span className="text-label">Show</span>
                                <select className="entries-select" value={limit}
                                    onChange={handleItemsPerPageChange}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="all">All</option>
                                </select>
                                <span className="text-label">Entries</span>
                            </div>
                            <div className="return-section showing-range">
                                {
                                    limit === 'all'
                                        ? `Showing all ${totalCount} entries`
                                        : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                }
                            </div>
                            <div className="return-section spacer"></div>
                            <div className="return-section pagination-buttons">
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange("first")}
                                ><Icon icon='mdi:chevron-double-left' /></button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange("prev")}
                                ><Icon icon='mdi:chevron-left' /></button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange("next")}
                                ><Icon icon='mdi:chevron-right' /></button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange("last")}
                                ><Icon icon='mdi:chevron-double-right' /></button>
                            </div>
                        </div>
                    </Box>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default ReturnList;